import { render, staticRenderFns } from "./ResourceChapters.vue?vue&type=template&id=56bcab12&"
import script from "./ResourceChapters.vue?vue&type=script&lang=ts&"
export * from "./ResourceChapters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports